// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZMlN","name":"styles_name__21UV7","phone":"styles_phone__3hHJT"};